import { getWidgetCategoryId } from '../selectors/app-settings-selectors';
import { getIsFeedPostsLoading, getIsCategoryLoading } from '../../app/selectors/is-loading-selectors';
import { getIsFeedPostsLoaded, getIsCategoryLoaded } from '../../app/selectors/is-loaded-selectors';
import { getFeedPosts, getSortedPostsByCategoryId } from '../../app/selectors/post-selectors';
import { SELECT_ALL_POSTS } from '../constants/select';

export const getWidgetPostsProps = (state) => {
  const categoryId = getWidgetCategoryId(state);
  return categoryId && categoryId !== SELECT_ALL_POSTS
    ? {
        categoryId,
        posts: getSortedPostsByCategoryId(state, categoryId),
        isLoading: getIsCategoryLoading(state, categoryId),
        isLoaded: getIsCategoryLoaded(state, categoryId),
      }
    : {
        categoryId: null,
        posts: getFeedPosts(state),
        isLoading: getIsFeedPostsLoading(state),
        isLoaded: getIsFeedPostsLoaded(state),
      };
};
